var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.values,"footer-props":{
        showFirstLastPage: true,
        'items-per-page-options': [10, 20, 50]
    }}})
}
var staticRenderFns = []

export { render, staticRenderFns }